<template>
  <div>
    <div :style="styles.renderingArea">
      <iframe :src="src" :style="styles.iframe" frameborder="0" allowfullscreen="true"></iframe>
    </div>
  </div>
</template>

<script>
export default {
  name: 'pdf-viewer',
  props: ['src'],
  data () {
    return {
      styles: {
        renderingArea: {
          background: '#f0f0f0',
          margin: '1rem 0',
          paddingBottom: 'calc(70%)',
          position: 'relative',
          width: '100%'
        },
        iframe: {
          height: '100%',
          left: 0,
          position: 'absolute',
          top: 0,
          width: '100%'
        }
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/app/misc/components/PdfViewer.vue